import { CompetitorPricingPage } from '../../components/comparisons/CompetitorPricingPage';
import { COMPETITOR_PRICING_MAX_AGE_DAYS, getCompetitorPricing } from '../../data/competitor-pricing';
import { warnStaleEntries } from '../../data/pseo/staleness';
import { isPublishable } from '../../data/pseo/types';

/**
 * Frame.io Pricing (2026): thin page over the shared pricing template. Numbers come from `competitor-pricing.ts`.
 */
const entry = getCompetitorPricing('frame-io');

const WHEN_COMPETITOR_IS_BETTER = [
    "You edit in Premiere Pro or After Effects and want review inside the app. Frame.io has a V4 panel for Premiere Pro 25.6 and later.",
    "You need to export comments: Frame.io exports CSV or plain text for Final Cut Pro, Media Composer, Premiere Pro and DaVinci Resolve, and prints comments to PDF.",
    "You want a free plan for 2 people across 2 projects. Kreatli’s free Exploration mode covers 1 project and 2 files.",
    "Your team has 11 to 15 people and you want a listed price. Frame.io Team covers up to 15 members; Kreatli above 10 members is Enterprise.",
];

export default function FrameIoPricingPage() {
  return (
    <CompetitorPricingPage
      entry={entry}
      documentTitle="Frame.io Pricing (2026): Plans, Limits & Real Cost"
      metaDescription="Frame.io pricing explained: Free, Pro ($15) and Team ($25) per member, seat caps, storage, and what 3, 5, 10 and 15 seats cost each month."
      h1="Frame.io Pricing (2026)"
      heroText="Frame.io plans, seat caps and storage, plus what a team of 3, 5, 10 or 15 actually pays each month, worked out from the official pricing page."
      publishDate="2026-10-22 00:00"
      readTimeMinutes="8"
      coverSrc="https://a.storyblok.com/f/287637539865613/2250x750/7b1d4796a1/kreatli-vs-frame-io-2026-the-freshest-most-practical-comparison-for-creative-teams.png"
      coverAlt="Frame.io pricing breakdown"
      summary="Frame.io charges per member: Pro covers up to 5 members and Team up to 15, and anything bigger is Enterprise with custom pricing. Share reviewers don’t need a seat. The free plan is capped at 2 members, 2 projects and 2GB, so most working teams end up on Pro or Team."
      whenCompetitorIsBetter={WHEN_COMPETITOR_IS_BETTER}
    />
  );
}

export function getStaticProps() {
  warnStaleEntries('competitor-pricing', [entry], COMPETITOR_PRICING_MAX_AGE_DAYS);
  if (!isPublishable(entry)) {
    return { notFound: true };
  }
  return { props: {} };
}
